import { Input } from '@material-ui/core'
import { useSnackbar } from 'notistack';
import React from 'react'
import OtpInput from 'react-otp-input';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import DenseAppBar from '../../components/AppBar' 
import AlertModal from '../../components/Modal';
import StatusAlert from '../../components/StatusAlert';
import { Reducers } from '../../Interfaces/Interfaces';
import { createAdmin } from '../../redux/actions/AdminActions';
import { administratorReducer } from '../../redux/reducers/appReducer';
import PrimaryTheme from '../../Themes/Primary'



export default function AddAdmin() {


  
const [gender, setGender] = React.useState("male");
const [admin, setAdmin]:any = React.useState({permission:{}});
const [permission, setPermission]:any = React.useState({});
const [firstnameValid, setFirstnameValid]: any = React.useState(null);
const [lastnameValid, setLastnameValid]: any = React.useState(null);
const [dob, setDob]: any = React.useState("");
const [email, setEmail] = React.useState("");
const [confirmEmail, setConfirmEmail] = React.useState("");
const [isEmailValid, setEmailValid]: any = React.useState(null);
const [isMatched, setIsMatched]: any = React.useState(null);
const [submitted] = React.useState(false);
const [firstName, setFirstname] = React.useState("");
const [lastName, setLastname] = React.useState("");
const [phoneNumber, setPhoneNumber] = React.useState("");
const [phoneNumberValid, setPhoneNumberValid]: any = React.useState(null);
const [confirmPhoneNumber, setConfirmPhoneNumber] = React.useState("");
const [ConfirmPhoneNumberValid, setConfirmPhoneNumberValid]: any =
  React.useState(null);
 
const [errorMessage, setErrorMessage] = React.useState("");
const history = useHistory();
const { enqueueSnackbar } = useSnackbar();
const dispatch = useDispatch();
const alert = useSelector((state: Reducers) => state.alert);
const [pin, setTransactionPin]=React.useState("");
const [transactionPinValid,setTransactionPinValid] :any= React.useState(null);
const [canAssignPos, setCanAssign]= React.useState(false);

const [canWithdrawCommission,setCanWithdrawCommission]=React.useState(false);
const [canOnboardAgent,setCanOnboardAgent]=React.useState(false);
const [canApproveFloat,setCanApproveFloat]=React.useState(false);
const [canDownloadReports,setCanDownloadReports]=React.useState(false);
const [canLogComplaints,setCanLogComplaints]=React.useState(false);
const [loading, setloading] = React.useState(false);
const validateName = (text: any, type: any) => {
  // minimum of one character
  let reg = /^[a-zA-Z]{1,}$/;
  if (!reg.test(text)) {
    if (type === "firstname") {
      setFirstname(text);      
      setFirstnameValid(false);
    } else {
      setLastname(text);
      setLastnameValid(false);
    }
  } else {
    if (type === "firstname") {
      setFirstname(text);
      setFirstnameValid(true);
    } else {
      setLastname(text);
      setLastnameValid(true);
    }
  }
};

const isEmailMatch = (text: string) => {
  setConfirmEmail(text);

  if (email === text) {
    setIsMatched(true);
  } else {
    setIsMatched(false);
  }
};

const isPhoneMatch = (text: string) => {
  setConfirmPhoneNumber(text);

  if (phoneNumber === text) {
    setConfirmPhoneNumberValid(true);
  } else {
    setConfirmPhoneNumberValid(false);
  }
};

const validateEmail = (text: string) => {
  // email pattern
  let reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/;
  if (!reg.test(text)) {
    setEmailValid(false);
    setEmail(text.toLowerCase());
  } else {
    setEmailValid(true);
    setEmail(text);
  }
};

const validatePhoneNumber = (text: string) => {
  // email pattern
  let reg = /^[0-9]{11,11}$/;
  if (!reg.test(text)) {
    setPhoneNumberValid(false);
    setPhoneNumber(text.toLowerCase());
  } else {
    setPhoneNumberValid(true);
    setPhoneNumber(text);
  }
};

const validateTransactionPin=(text:string)=>{
  let reg = /^[0-9]{4,4}$/;
  if (!reg.test(text)) {
    setTransactionPinValid(false);
    setTransactionPin(text);
  } else {
    setTransactionPinValid(true);
    setTransactionPin(text);
  }
}
const showValue=(e:any)=>{
  console.log(e);
}

 

const handleSubmit=(e:any)=>{

  e.preventDefault();
setErrorMessage("");
  dispatch({
    type: 'LOADING',
    payload: true
  });

  dispatch({
    type: 'ALERT_MODAL',
    payload: false
  })
  const admin={
    firstName,
    lastName,
    emailAddress:email,
    phoneNumber,
    pin,
   permission:{
     canOnboardAgent:canOnboardAgent||false,
     canApproveFloat:canApproveFloat||false,
     canAssignPos:canAssignPos||false,
     canDownloadReports:canDownloadReports||false,
     canLogComplaints:canLogComplaints||false,
     canWithdrawCommission     :canWithdrawCommission||false
   }

  };
  console.log(admin);
  dispatch(createAdmin(admin));
}
const closeModal = () => {
  
  dispatch({ type: "ALERT_MODAL", payload: false })
  dispatch({ type: "STATUS_ALERT", payload: false })
}
const closeAlert = () => {
  
  dispatch({ type: "STATUS_ALERT", payload: false });
  window.location.reload();
}
const handleOTP = (e: any) => {
  e.preventDefault();

  dispatch({
      type: 'ALERT_MODAL',
      payload: true
  })
};
React.useEffect(() => {
  dispatch({
    type: "STATUS_ALERT",
    payload: false
  });
}, [])
React.useEffect(() => {
  if (Object.entries(alert).length !== 0) {
    if (!alert.successful) {

      // display error message
      enqueueSnackbar(alert.message, { variant: "error" });
      setErrorMessage(alert.message);
      setTransactionPin("");
      dispatch({
        type: 'LOADING',
        payload: false
      })

      dispatch({
        type: 'ALERT',
        payload: {}
      });

    } else {

     

     setloading(false)
     setTransactionPin("")

      if (alert.message === "Successful") {
        dispatch({
          type: "STATUS_ALERT",
          payload: true
        });
      }
      dispatch({
        type: 'ALERT_MODAL',
        payload: false
      })
      dispatch({
        type: 'LOADING',
        payload: false
      })

      dispatch({
        type: 'ALERT',
        payload: {}
      });
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [dispatch, enqueueSnackbar, alert, history]);

    return (
        <div>
           <div className="col-md-11 mr-auto ml-auto p-0" style={{
        height: 'auto',
        position: "relative",
      }}>
          
        <DenseAppBar canGoBack />
        <div className="col-md-12 p-0">
            <h1 style={{
              fontFamily: PrimaryTheme.fonts?.MediumFont,
              textTransform: "uppercase",
              fontSize: PrimaryTheme.fontSizes?.subtitle
            }}>Add New Administrator</h1>

           
          </div>



          <div className="col-md-6 ml-auto mr-auto mb-5">


           {errorMessage && 
             <div className="alert alert-danger">
               {errorMessage}
             </div>
           }
           
              <form noValidate>
                
                    <div className="form-group">
                      <label
                        htmlFor="firstname"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        First Name
                      </label>
                      <input
                        type="text"
                        placeholder="Enter First Name"
                        autoComplete="firstname"
                        required
                        id="firstname"
                        value={firstName}
                        disabled={submitted}
                        inputMode="text"
                        className="form-control"
                        onChange={(e) =>
                          validateName(e.target.value, "firstname")
                        }
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                        
                      />
                    </div>

                    <div className="form-group mt-4">
                      <label
                        htmlFor="lastname"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Last Name
                      </label>
                      <Input
                        type="text"
                        placeholder="Enter Last Name"
                        autoComplete="lastname"
                        required
                        id="lastname"
                        className="form-control"
                        value={lastName}
                        disabled={submitted}
                        inputMode="text"
                        onChange={(e) =>
                          validateName(e.target.value, "lastname")
                        }
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div>

                    <div className="form-group mt-4">
                      <label
                        htmlFor="email"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Email Address
                      </label>
                      <Input
                        type="email"
                        placeholder="Enter Email Address"
                        autoComplete="email"
                        required
                        id="email"
                        className="form-control"
                        value={email}
                        disabled={submitted}
                        inputMode="email"
                        onChange={(e) => validateEmail(e.target.value)}
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div>

                    <div className="form-group mt-4">
                      <label
                        htmlFor="confirmEmail"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Confirm Email Address
                      </label>
                      <input
                        type="email"
                        placeholder="Confirm Email Address"
                        autoComplete="email"
                        required
                        id="confirmEmail"
                        value={confirmEmail}
                        disabled={submitted}
                        inputMode="email"
                        className="form-control"
                        onChange={(e) => isEmailMatch(e.target.value)}
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div>

                    <div className="form-group mt-4">
                      <label
                        htmlFor="phoneNumber"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        placeholder="Enter Phone Number"
                        autoComplete="phoneNumber"
                        required
                        id="phoneNumber"
                        value={phoneNumber}
                        disabled={submitted}
                        className="form-control"
                        inputMode="tel"
                        onChange={(e) => validatePhoneNumber(e.target.value)}
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div>
                    <div className="form-group mt-4">
                      <label
                        htmlFor="confirmPhoneNumber"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Confirm Phone Number
                      </label>
                      <input
                        type="tel"
                        placeholder="Confirm Phone Number"
                        autoComplete="phoneNumber"
                        required
                        id="confirmPhoneNumber"
                        value={confirmPhoneNumber}
                        disabled={submitted}
                        className="form-control"
                        inputMode="tel"
                        onChange={(e) => isPhoneMatch(e.target.value)}
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div>

                    <h3>Roles</h3>
                    <p>Select Activity to be performed by staff</p>

                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" 
                      checked={canAssignPos}
                      onChange={(e) => setCanAssign(!canAssignPos)}
                      id="canAssignPos"/>
                      <label className="form-check-label" htmlFor="canAssignPos">
                        Assign POS
                      </label>
                    </div>
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" checked={canWithdrawCommission} 
                      onChange={(e) => setCanWithdrawCommission(!canWithdrawCommission)}
                      id="canWithdrawCommission"/>
                      <label className="form-check-label" htmlFor="canWithdrawCommission">
                        Withdraw Commission
                      </label>
                    </div>

                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" checked={canOnboardAgent} 
                      onChange={(e) => setCanOnboardAgent(!canOnboardAgent)}
                      id="canOnboardAgent"/>
                      <label className="form-check-label" htmlFor="canOnboardAgent">
                        Onboard Agents
                      </label>
                    </div>
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" checked={canApproveFloat} 
                      onChange={(e) => setCanApproveFloat(!canApproveFloat)}
                      id="canApproveFloat"/>
                      <label className="form-check-label" htmlFor="canApproveFloat">
                        Approve Float
                      </label>
                    </div>

                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" checked={canDownloadReports} 
                      onChange={(e) => setCanDownloadReports(!canDownloadReports)}
                      id="canDownloadReports"/>
                      <label className="form-check-label" htmlFor="canDownloadReports">
                        Download Reports
                      </label>
                    </div>

                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" checked={canLogComplaints} 
                      onChange={(e) => setCanLogComplaints(!canLogComplaints)}
                      id="canLogComplaint"/>
                      <label className="form-check-label" htmlFor="canLogComplaint">
                        Resolve and Escalate Complaints
                      </label>
                    </div>
                     
                     

                    {/* <div className="form-group mt-4">
                      <label
                        htmlFor="transactionPin"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                       Transaction PIN
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Transaction Pin"
                        required
                        id="transactionPin"
                        value={pin}
                        disabled={submitted}
                        className="form-control"
                        onChange={(e) => validateTransactionPin(e.target.value)}
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div> */}

                 

                    <div className="form-group mt-5 col-md-12 ml-auto mr-auto text-right">
                      <input
                         onClick={handleOTP}
                        type="submit"
                        className="btn btn-primary btn-justified"
                        value="Submit"
                        disabled={
                          !firstnameValid ||
                          !lastnameValid ||
                          !isEmailValid ||
                          !phoneNumberValid ||
                          !ConfirmPhoneNumberValid 
                        }
                        style={{
                          background: PrimaryTheme.primary,
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.white,
                        }}
                      />
                    </div>
                
 
              </form>
            </div>
            <AlertModal>
                    <div className="col-md-12 p-5 text-center">
                        <div className="col-md-12">
                            <span className="badge-pill p-3 d-block col-7 ml-auto mr-auto" style={{
                                background: PrimaryTheme.warn,
                                fontFamily: PrimaryTheme.fonts?.MediumFont,
                            }}>Enter PIN</span>
                        </div>

                        <p className="mt-3 mb-5" style={{
                            fontFamily: PrimaryTheme.fonts?.RegularFont,
                            fontSize: 18,
                            color: PrimaryTheme.light
                        }}>Enter your 4 Digit Transaction PIN to authorize this operation</p>

                        <div className="row m-0 justify-content-center align-items-center">
                            <OtpInput
                                value={pin}
                                onChange={(e: any) => setTransactionPin(e)}
                                numInputs={4}
                                isInputNum
                                shouldAutoFocus
                                inputStyle={{
                                    width: '45px',
                                    height: '45px',
                                    fontSize: '24px',
                                    padding: 0,
                                    textAlign: 'center',
                                    borderRadius: 10,
                                    border: "1px solid",
                                    borderColor: PrimaryTheme.primary
                                }}
                                isInputSecure
                                separator={<span className="mr-3">  </span>}
                            />
                        </div>

                        <div className="form-group mt-5 mb-0">
                            <Input
                                onClick={handleSubmit}
                                type='button'
                                
                                value={loading ? "Saving..." : 'Submit'}
                                disabled={pin.length === 0}
                                style={{
                                    background: PrimaryTheme.primary,
                                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                                    color: PrimaryTheme.white
                                }} className='text-bold border-0 col-md-6' /> 
                        </div>
                    </div>
                </AlertModal>
            <StatusAlert
                    subtitle="An email has been sent to the email provided. The email contains a default password which admin is expected to update upon login"
                    title="Invite Sent"
                    buttonTitle="Add New Admin"
                    backTitle="Back to Administrators"
                    onClick={closeAlert}
                    goBack={() => history.push('/admins')}
                ></StatusAlert>
      </div>
     
        </div>
    )
} 


